import 'react';

import PartsContent from './parts-content';

type TPartFilter = {
  groups: TCategories;
  currentPart: string;
};

const PartsFilter = (
  {
    groups,
    currentPart,
    ref
  }: TPartFilter
) => {
  return <PartsContent ref={ref} groups={groups} currentPart={currentPart} />;
};

PartsFilter.displayName = 'PartsFilter';

export default PartsFilter;
